// src/components/resources/tools/generators/SocialMediaMockup/socialMediaFormatting.ts
//
// Pure display formatters extracted from SocialMediaMockupGenerator so the
// preview subcomponents and unit tests can share one implementation.

import type { SocialMediaConfig } from './types'

/**
 * Format a metric value for display (e.g., 1.2K, 3.4M).
 * @param {number} value The metric value.
 * @returns {string} Formatted string.
 */
export function formatMetric(value: number): string {
  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(1)}M`
  }
  if (value >= 1_000) {
    return `${(value / 1_000).toFixed(1)}K`
  }
  return value.toString()
}

/**
 * Format an `@handle` for the vertical formats: strips a leading `@` from the
 * configured handle (the layout adds its own). When the handle is blank, falls
 * back to a slugified username — lowercased, with characters outside the
 * handle-safe set (letters, digits, `.` and `_`) removed — so the result reads
 * like a real handle rather than a display name with spaces.
 */
export function formatVerticalHandle(config: SocialMediaConfig): string {
  const handle = config.handle.trim().replace(/^@+/, '')
  if (handle.length > 0) return handle
  const slug = (config.username || 'adsights').toLowerCase().replace(/[^a-z0-9._]/g, '')
  return slug.length > 0 ? slug : 'adsights'
}
